import React from 'react';

import SegmentedControl from 'CommonComponents/SegmentedControl';

/**
 * The commitment-layer switch above an expenditure R&E table.
 *
 * Total shows the funding figures; Committed / Uncommitted re-base the Total and
 * Qty columns to the line's committed / uncommitted split (cash/vik render
 * blank); Split keeps the Total row and reveals the two-figure split beneath
 * every leaf. In-memory only — the selection resets on reload (IB-654 convention).
 */
export const COMMITMENT_LAYERS = {
    TOTAL: 'total',
    COMMITTED: 'committed',
    UNCOMMITTED: 'uncommitted',
    SPLIT: 'split',
};

export default function CommitmentLayerControl({ value, onChange, className }) {
    const options = [
        { value: COMMITMENT_LAYERS.TOTAL, label: $t('Total') },
        { value: COMMITMENT_LAYERS.COMMITTED, label: $t('Committed') },
        { value: COMMITMENT_LAYERS.UNCOMMITTED, label: $t('Uncommitted') },
        { value: COMMITMENT_LAYERS.SPLIT, label: $t('Split') },
    ];

    return <SegmentedControl options={options} value={value} onChange={onChange} className={className} variant="default" />;
}
